import React, { useState, useEffect, FunctionComponent } from 'react';

interface Props {
  name: string;
  size?: number;
  fill?: string;
  path?: string;
}

interface EmptyProps {}

const Icon: FunctionComponent<Props> = ({ name, size = 16, fill = '#000', path = '' }) => {
  const [loading, setLoading] = useState(false);
  const [iconPath, setIconPath] = useState(undefined);

  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        const { default: namedImport } = await import(`./svg${path ? `/${path}` : ''}/${name}.svg`);
        setIconPath(namedImport);
      } catch (err) {
        console.warn(err);
        setIconPath(undefined);
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name, path]);

  if (!loading && iconPath) {
    return <img src={iconPath} alt="name" />;
  }

  return null;
};

export default Icon;
